<template>
  <div class="flex items-center border rounded-lg py-2 mt-4">
    <img class="w-16 rounded-lg" :src="food.imgurl" alt=""
         @error="$event.target.src = require('@/assets/img/food_placeholder.png')" >
    <div class="mr-2">
      <h1 class="text-sm">{{ food.kala_Name }}</h1>
      <h3 class="text-xs mt-1 text-gray-500">
        قیمت:
        <span :class="food.isNegative === -1 ? 'text-red-500' : 'text-ColorNerkh font-bold'">
          <span>{{ $helper.priceFormatter(food.nerkh / 10, false) }}</span>
        </span>
        تومان
      </h3>
    </div>
    <div class="flex items-center ml-4 mr-auto text-sm">
      <span class="bg-theme-500 px-2 py-0.5 text-white rounded font-bold" @click="incrementCount">+</span>
      <span class="px-2">{{ food.quantity }}</span>
      <span class="border border-theme-500  px-2 py-0.5 rounded font-bold" @click="decrementCount">-</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CartFoodCard",
  props: ['food'],
  methods: {
    incrementCount() {
      this.$store.dispatch('addProduct', this.food)
          .catch(err => {
            this.$swal({
              icon: 'error',
              title: 'خطا',
              text: err,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
          })
    },
    decrementCount() {
      this.$store.dispatch('removeProduct', this.food)
    },
  }
}
</script>

<style scoped>

</style>